export default {
    key: process.env.REACT_APP_TOKEN_KEY || "authToken"
}